import React, { useEffect, useState } from 'react';
import { Helpers } from '../../Helpers';
import SubformInputs from './subformInputs';

const DynamicTable = ({ section, storeData, sectionIndex, setStoreData, preview, users, lookupData = null, currentCurrencyData, rowTax, setRowTax, isOverallTax, rowDiscount, setRowDiscount, showFrom, executeFrom, moduleName, jobSuggestionData }) => {
    // let [rows, setRows] = useState(!preview ? storeData.data[sectionIndex].section_data["table_data"] : [{}] || [{}]);
    let [rows, setRows] = useState(() => {
        const initialRows = !preview ? (storeData?.data?.[sectionIndex]?.section_data?.table_data || [{}]) : [{}];
        return initialRows.map((row) => ({ ...row, Email_isPrimary: row?.Email_isPrimary }));
    });

    const handlePrimaryEmailChange = (rowIndex) => {
        if (!preview && moduleName === 'Prospects') {
            let updatedRows = rows.map((row, rIndex) => ({
                ...row,
                Email_isPrimary: rIndex === rowIndex
            }));

            if (!updatedRows.some((row) => row.Email_isPrimary)) {
                updatedRows[0].Email_isPrimary = true;
            }

            setRows(updatedRows);
            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };
    let addRow = () => {
        if (!preview) {
            let newRow = Object.assign({}, ...section.selected_list.map(x => ({
                [Helpers.replaceData(x?.extra_fields?.field_label)]: ""
            })));
            newRow['Discount_Type'] = 'amount';
            let updatedRows = [...rows, newRow];
            setRows(updatedRows);

            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);

            const newobj = {
                discount_type: 'amount',
                percentage: '',
                discount_amount: ''
            }
            setRowDiscount('new', newobj)
            const taxobj = {
                tax_type: 'percentage',
                tax_percentage: '',
                tax_amount: ''
            }
            setRowTax('new', taxobj)
        }
    };

    let removeRow = (rowIndex) => {
        if (!preview) {
            let updatedRows = rows.filter((_, index) => index !== rowIndex);
            if (updatedRows?.length === 0) return;
            setRows(updatedRows);

            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };

    const extractNumbers = (str) => {
        return str.replace(/\D/g, "");
    };

    let getProductDetails = (product) => {
        let price, tax;
        lookupData?.['Product Name']?.map((data) => {
            if (product === data?.data?.[0]?.section_data?.Product_Name) {
                price = data?.data?.[1]?.section_data?.Unit_Price
                if (data?.data?.[1]?.section_data?.Taxable === "X") {
                    tax = extractNumbers(data?.data?.[1]?.section_data?.Tax)
                }
            }
        })
        return { price, tax }
    }

    let handleInputChange = async (rowIndex, colIndex, value) => {
        if (!preview) {
            let updatedRows = rows.map((row, rIndex) => {
                const { price, tax } = getProductDetails(value)
                if (rIndex === rowIndex) {
                    if (colIndex === 1) {
                        return {
                            ...row,
                            [Helpers.replaceData(section?.selected_list?.[colIndex]?.extra_fields?.field_label)]: value,
                            [Helpers.replaceData(section?.selected_list?.[colIndex + 1]?.extra_fields?.field_label)]: (moduleName === 'Quotes' || moduleName === 'Sales Orders' || moduleName === 'Invoices') ? 1 : '',
                            [Helpers.replaceData(section?.selected_list?.[colIndex + 2]?.extra_fields?.field_label)]: price,
                            [Helpers.replaceData(section?.selected_list?.[colIndex + 5]?.extra_fields?.field_label)]: tax
                        };
                    } else {
                        return { ...row, [Helpers.replaceData(section?.selected_list?.[colIndex]?.extra_fields?.field_label)]: value };
                    }
                } else {
                    return row;
                }
            }
            );
            setRows(updatedRows);
            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };

    let handleCustomInputChange = async (rowIndex, colIndex, value) => {
        if (!preview) {
            let updatedRows = rows.map((row, rIndex) => {
                const { price, tax } = getProductDetails(value)
                if (rIndex === rowIndex) {
                    if (colIndex === 1) {
                        return {
                            ...row,
                            [Helpers.replaceData(section?.selected_list?.[colIndex]?.extra_fields?.field_label)]: value,
                            [Helpers.replaceData(section?.selected_list?.[colIndex + 1]?.extra_fields?.field_label)]: (moduleName === 'Quotes' || moduleName === 'Sales Orders' || moduleName === 'Invoices') ? 1 : '',
                            [Helpers.replaceData(section?.selected_list?.[colIndex + 2]?.extra_fields?.field_label)]: price,
                            [Helpers.replaceData(section?.selected_list?.[colIndex + 5]?.extra_fields?.field_label)]: tax
                        };
                    } else {
                        return { ...row, [Helpers.replaceData(section?.selected_list?.[colIndex]?.extra_fields?.field_label)]: value };
                    }
                } else {
                    return row;
                }
            }
            );
            setRows(updatedRows);
            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };

    const formatNumber = (amount) => {
        return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
            style: "decimal",
            minimumFractionDigits: currentCurrencyData?.decimal_place,
            maximumFractionDigits: currentCurrencyData?.decimal_place,
        }).format(amount);
    };

    const convertStrFormula = (formula) => {
        return formula.replace(/[\d.,\s]+/g, (match) => {
            let updatedFormula = match.replace(/\s/g, '');
            if (updatedFormula.match(/[.,]*,\d+$/)) {
                updatedFormula = updatedFormula.replace(/\./g, '').replace(',', '.');
            }
            else if (updatedFormula.match(/,\d{3}/) && updatedFormula.includes('.')) {
                updatedFormula = updatedFormula.replace(/,/g, '');
            }
            else if (updatedFormula.match(/,\d{3}/)) {
                updatedFormula = updatedFormula.replace(/,/g, '');
            }
            const num = parseFloat(updatedFormula);
            return Number.isNaN(num) ? match : num.toString();
        });
    }

    const handleBlur = (rowIndex, label) => {
        if (!preview) {
            let formulas = section.selected_list?.filter(x => x?.input_type === 'formula');
            let updatedRows = [...rows];
            updatedRows = rows.map(row => {
                if (label === 'List Price') {
                    let price = formatNumber(convertStrFormula(row.List_Price));
                    return { ...row, List_Price: price };
                }
                return row;
            });

            let _amount; let _taxAmount; let _discountAmount;
            formulas?.forEach((checkFormula) => {
                let expression = checkFormula?.extra_fields?.formula_expression;
                if (checkFormula?.extra_fields?.field_label === 'Total') {
                    if (rowDiscount[rowIndex]?.discount_type === 'amount') {
                        expression = checkFormula?.extra_fields?.formula_expression;
                    } else {
                        expression = '(${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))+(((${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))*${Subform 1.Tax})/100)'
                    }
                }
                let checkIndex = section.selected_list?.findIndex(x => x?.extra_fields?.field_label === checkFormula?.extra_fields?.field_label);
                let calculateFormula = (formula, product) => {
                    return formula?.replace(/\${(.*?)}/g, (match, variable) => {
                        let keys = variable?.split('.');
                        return product?.[Helpers.replaceData(keys?.[1])] || 0;
                    });
                };
                if (expression) {
                    let row = updatedRows[rowIndex];
                    let processedFormula = calculateFormula(expression, row);
                    processedFormula = convertStrFormula(processedFormula)
                    let result;
                    try {
                        result = eval(processedFormula);
                        _amount = convertStrFormula(row.Amount)
                        if (rowDiscount[rowIndex]?.discount_type === 'amount') {
                            _taxAmount = (_amount - Number(row.Discount)) * Number(row.Tax) / 100
                            _discountAmount = ""
                        } else {
                            _taxAmount = (_amount - (_amount * Number(row.Discount) / 100)) * Number(row.Tax) / 100
                            _discountAmount = _amount * Number(row.Discount) / 100
                        }
                    } catch (error) {
                        console.error("Error evaluating formula:", error);
                        return;
                    }
                    updatedRows[rowIndex] = {
                        ...row,
                        [Helpers.replaceData(section?.selected_list?.[checkIndex]?.extra_fields?.field_label)]: formatNumber(result)
                    };
                }
            });
            // if (_taxAmount) {
            setRowTax('rowupdate', { index: rowIndex, amount: _taxAmount })
            setRowDiscount('rowupdateamount', { index: rowIndex, amount: _discountAmount })
            // }
            setRows(updatedRows);
            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };

    const updateValues = (rowIndex, type) => {
        if (!preview) {
            let formulas = section.selected_list?.filter(x => x?.input_type === 'formula');
            let updatedRows = [...rows];
            let _amount; let _taxAmount; let _discountAmount;
            formulas?.forEach((checkFormula) => {
                let expression = checkFormula?.extra_fields?.formula_expression;
                if (checkFormula?.extra_fields?.field_label === 'Total') {
                    if (type === 'amount') {
                        expression = checkFormula?.extra_fields?.formula_expression;
                    } else {
                        expression = '(${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))+(((${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))*${Subform 1.Tax})/100)'
                    }
                }
                let checkIndex = section.selected_list?.findIndex(x => x?.extra_fields?.field_label === checkFormula?.extra_fields?.field_label);
                let calculateFormula = (formula, product) => {
                    return formula?.replace(/\${(.*?)}/g, (match, variable) => {
                        let keys = variable?.split('.');
                        return product?.[Helpers.replaceData(keys?.[1])] || 0;
                    });
                };
                if (expression) {
                    let row = updatedRows[rowIndex];
                    let processedFormula = calculateFormula(expression, row);
                    processedFormula = convertStrFormula(processedFormula)
                    let result;
                    try {
                        result = eval(processedFormula);
                        _amount = convertStrFormula(row.Amount)
                        if (rowDiscount[rowIndex]?.discount_type === 'amount') {
                            _taxAmount = (_amount - Number(row.Discount)) * Number(row.Tax) / 100
                            _discountAmount = ""
                        } else {
                            _taxAmount = (_amount - (_amount * Number(row.Discount) / 100)) * Number(row.Tax) / 100
                            _discountAmount = _amount * Number(row.Discount) / 100
                        }
                    } catch (error) {
                        console.error("Error evaluating formula:", error);
                        return;
                    }

                    updatedRows[rowIndex] = {
                        ...row,
                        [Helpers.replaceData(section?.selected_list?.[checkIndex]?.extra_fields?.field_label)]: formatNumber(result)
                    };
                }
            });
            // if (_taxAmount) {
            setRowTax('rowupdate', { index: rowIndex, amount: _taxAmount })
            setRowDiscount('rowupdateamount', { index: rowIndex, amount: _discountAmount })
            // }
            setRows(updatedRows);
            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };

    const updateValues1 = (rowIndex, type) => {
        if (!preview) {
            let formulas = section.selected_list?.filter(x => x?.input_type === 'formula');
            let updatedRows = [...rows];
            let _amount; let _taxAmount; let _discountAmount;
            formulas?.forEach((checkFormula) => {
                let expression = checkFormula?.extra_fields?.formula_expression;
                if (checkFormula?.extra_fields?.field_label === 'Total') {
                    if (type === 'amount') {
                        expression = checkFormula?.extra_fields?.formula_expression;
                    } else {
                        expression = '(${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))+(((${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))*${Subform 1.Tax})/100)'
                    }
                }
                let checkIndex = section.selected_list?.findIndex(x => x?.extra_fields?.field_label === checkFormula?.extra_fields?.field_label);
                let calculateFormula = (formula, product) => {
                    return formula?.replace(/\${(.*?)}/g, (match, variable) => {
                        let keys = variable?.split('.');
                        return product?.[Helpers.replaceData(keys?.[1])] || 0;
                    });
                };
                if (expression) {
                    let row = updatedRows[rowIndex];
                    let processedFormula = calculateFormula(expression, row);
                    processedFormula = convertStrFormula(processedFormula)
                    let result;
                    try {
                        result = eval(processedFormula);
                        _amount = convertStrFormula(row.Amount)
                        if (type === 'amount') {
                            _taxAmount = (_amount - Number(row.Discount)) * Number(row.Tax) / 100
                            _discountAmount = ""
                        } else {
                            _taxAmount = (_amount - (_amount * Number(row.Discount) / 100)) * Number(row.Tax) / 100
                            _discountAmount = _amount * Number(row.Discount) / 100
                        }
                    } catch (error) {
                        console.error("Error evaluating formula:", error);
                        return;
                    }

                    updatedRows[rowIndex] = {
                        ...row,
                        [Helpers.replaceData(section?.selected_list?.[checkIndex]?.extra_fields?.field_label)]: formatNumber(result)
                    };
                }
            });
            // if (_taxAmount) {
            setRowTax('rowupdate', { index: rowIndex, amount: _taxAmount })
            setRowDiscount('rowupdateamount', { index: rowIndex, amount: _discountAmount })
            // }
            setRows(updatedRows);
            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };

    const updateTaxValues = (rowIndex, type) => {
        if (!preview) {
            let formulas = section.selected_list?.filter(x => x?.input_type === 'formula');
            let updatedRows = [...rows];
            let _amount; let _taxAmount; let _discountAmount;
            formulas?.forEach((checkFormula) => {
                let expression = checkFormula?.extra_fields?.formula_expression;
                if (checkFormula?.extra_fields?.field_label === 'Total') {
                    let discType = rowDiscount[rowIndex].discount_type
                    if (discType === 'amount') {
                        expression = checkFormula?.extra_fields?.formula_expression;
                    } else {
                        discType = '(${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))+(((${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))*${Subform 1.Tax})/100)'
                    }
                }
                let checkIndex = section.selected_list?.findIndex(x => x?.extra_fields?.field_label === checkFormula?.extra_fields?.field_label);
                let calculateFormula = (formula, product) => {
                    return formula?.replace(/\${(.*?)}/g, (match, variable) => {
                        let keys = variable?.split('.');
                        return product?.[Helpers.replaceData(keys?.[1])] || 0;
                    });
                };
                if (expression) {
                    let row = updatedRows[rowIndex];
                    let processedFormula = calculateFormula(expression, row);
                    processedFormula = convertStrFormula(processedFormula)
                    let result;
                    try {
                        result = eval(processedFormula);
                        _amount = convertStrFormula(row.Amount)
                        if (rowDiscount[rowIndex]?.discount_type === 'amount') {
                            _taxAmount = (_amount - Number(row.Discount)) * Number(row.Tax) / 100
                            _discountAmount = ""
                        } else {
                            _taxAmount = (_amount - (_amount * Number(row.Discount) / 100)) * Number(row.Tax) / 100
                            _discountAmount = _amount * Number(row.Discount) / 100
                        }
                    } catch (error) {
                        console.error("Error evaluating formula:", error);
                        return;
                    }

                    updatedRows[rowIndex] = {
                        ...row,
                        [Helpers.replaceData(section?.selected_list?.[checkIndex]?.extra_fields?.field_label)]: formatNumber(result)
                    };
                }
            });
            // if (_taxAmount) {
            setRowTax('rowupdate', { index: rowIndex, amount: _taxAmount })
            setRowDiscount('rowupdateamount', { index: rowIndex, amount: _discountAmount })
            // }
            setRows(updatedRows);
            let updatedStoreData = JSON.parse(JSON.stringify(storeData));
            updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
            setStoreData(updatedStoreData);
        }
    };
    // dp changes
    // useEffect(() => {
    //     if (executeFrom !== "create_task") {
    //         if (rows?.length && !rowDiscount?.length) {
    //             let newArr = Array.from({ length: rows?.length }, () => ({
    //                 discount_type: 'amount',
    //                 percentage: '',
    //                 discount_amount: ''
    //             }));
    //             setRowDiscount('initial', newArr)
    //         }
    //         if (rows?.length && !rowTax?.length) {
    //             let newArr = Array.from({ length: rows?.length }, () => ({
    //                 tax_type: 'percentage',
    //                 tax_percentage: '',
    //                 tax_amount: ''
    //             }));
    //             setRowTax('initial', newArr)
    //         }
    //     }
    // }, [rows])
    useEffect(() => {
        if (executeFrom !== "create_task") {
            if (rows?.length && !rowDiscount?.length && setRowDiscount) {
                let newArr = Array.from({ length: rows?.length }, () => ({
                    discount_type: 'amount',
                    percentage: '',
                    discount_amount: ''
                }));
                setRowDiscount('initial', newArr);
            }
            if (rows?.length && !rowTax?.length && setRowTax) {
                let newArr = Array.from({ length: rows?.length }, () => ({
                    tax_type: 'percentage',
                    tax_percentage: '',
                    tax_amount: ''
                }));
                setRowTax('initial', newArr);
            }
        }
    }, [rows, setRowDiscount, setRowTax]); // Add setRowDiscount, setRowTax to dependencies


    const handleRowDiscount = (index, type, value, input_type, field_label) => {
        setRowDiscount('update', { index: index, type: type, value: value })
        updateValues(index, type)
    }
    const updateRowDicount = (obj) => {
        setRowDiscount('rowupdate', { index: obj.index, value: obj.value })
        updateValues1(obj.index, obj.value)
    }

    const handleRowTax = (index, type) => {
        updateTaxValues(index, type)
    }

    const updateTableCalculation = () => {
        let formulas = section.selected_list?.filter(x => x?.input_type === 'formula');
        let updatedRows = [...rows];
        for (var rowIndex = 0; rowIndex < updatedRows.length; rowIndex++) {
            formulas?.forEach((checkFormula) => {
                let expression = checkFormula?.extra_fields?.formula_expression;
                if (checkFormula?.extra_fields?.field_label === 'Total') {
                    if (rowDiscount[rowIndex]?.discount_type === 'amount') {
                        expression = '(${Subform 1.Amount}-${Subform 1.Discount})'
                    } else {
                        expression = '(${Subform 1.Amount}-((${Subform 1.Amount}*${Subform 1.Discount})/100))'
                    }
                }
                let checkIndex = section.selected_list?.findIndex(x => x?.extra_fields?.field_label === checkFormula?.extra_fields?.field_label);
                let calculateFormula = (formula, product) => {
                    return formula?.replace(/\${(.*?)}/g, (match, variable) => {
                        let keys = variable?.split('.');
                        return product?.[Helpers.replaceData(keys?.[1])] || 0;
                    });
                };
                if (expression) {
                    let row = updatedRows[rowIndex];
                    let processedFormula = calculateFormula(expression, row);
                    processedFormula = convertStrFormula(processedFormula)
                    let result;

                    try {
                        result = eval(processedFormula);
                    } catch (error) {
                        console.error("Error evaluating formula:", error);
                        return;
                    }
                    updatedRows[rowIndex] = {
                        ...row,
                        "Tax": "",
                        [Helpers.replaceData(section?.selected_list?.[checkIndex]?.extra_fields?.field_label)]: formatNumber(result)
                    };
                }
            })
        }
        setRows(updatedRows);
        let updatedStoreData = JSON.parse(JSON.stringify(storeData));
        updatedStoreData.data[sectionIndex].section_data["table_data"] = updatedRows;
        setStoreData(updatedStoreData);
    }

    useEffect(() => {
        if (isOverallTax) {
            updateTableCalculation();
            setRowTax("clear", "")
        }
    }, [isOverallTax])

    return (
        <div className='sub-form'>
            <div className="table-responsive">
                <table className="table mb-0">
                    <thead>
                        <tr>
                            {section.selected_list.map((x, idx) => (
                                <th style={{ width: x?.extra_fields?.field_label === "S.NO" ? "50px" : "" }} key={idx} scope="col">{x?.extra_fields?.field_label}</th>
                            ))}
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {section.selected_list.map((col, colIndex) => (
                                    <td key={colIndex} className="text-center">
                                        {
                                            col?.extra_fields?.field_label === "Email" &&
                                                moduleName === "Prospects" ? (
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        checked={row.Email_isPrimary || false}
                                                        onChange={() => handlePrimaryEmailChange(rowIndex)}
                                                        disabled={preview}
                                                        className="me-2"
                                                    />
                                                    <SubformInputs
                                                        item={col}
                                                        labelValue={row[Helpers.replaceData(col?.extra_fields?.field_label)] || ""}
                                                        error={false}
                                                        handleInputChange={(e) =>
                                                            handleInputChange(rowIndex, colIndex, e.target.value)
                                                        }
                                                        handleBlur={() =>
                                                            handleBlur(rowIndex, col?.extra_fields?.field_label, col?.input_type)
                                                        }
                                                        users={users}
                                                        lookupData={lookupData}
                                                        preview={preview}
                                                        currentCurrencyData={currentCurrencyData}
                                                        rowData={row}
                                                        sectionData={section}
                                                        rowIndex={rowIndex}
                                                        rowDiscount={rowDiscount}
                                                        handleRowDiscount={handleRowDiscount}
                                                        updateRowDicount={updateRowDicount}
                                                        rowTax={rowTax}
                                                        handleRowTax={handleRowTax}
                                                        input_type={col?.input_type}
                                                        field_label={col?.extra_fields?.field_label}
                                                        isOverallTax={isOverallTax}
                                                        showFrom={showFrom}
                                                        jobSuggestionData={jobSuggestionData}
                                                    />
                                                </div>
                                            ) : col?.input_type === "formula" ?
                                                <>
                                                    <div className="form-group mb-0">
                                                        <div className="col-auto input-control w-100" style={{ minWidth: '140px' }}>
                                                            <input
                                                                type={col?.input_type}
                                                                className="form-control"
                                                                value={row[Helpers.replaceData(col?.extra_fields?.field_label)] || ""}
                                                                placeholder={col?.label}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                col?.input_type === "auto_number" ?
                                                    <>
                                                        <span>{rowIndex + 1}</span>
                                                    </> :
                                                    <>
                                                        <SubformInputs item={col} labelValue={row[Helpers.replaceData(col?.extra_fields?.field_label)] || (col?.extra_fields?.default_value || '')}
                                                            error={false} handleInputChange={(e) => handleInputChange(rowIndex, colIndex, e?.target?.value || e?.value)}
                                                            handleCustomInputChange={(e) => handleCustomInputChange(rowIndex, colIndex, e.value)}
                                                            handleBlur={() => handleBlur(rowIndex, col?.extra_fields?.field_label, col?.input_type)}
                                                            users={users} lookupData={lookupData} preview={preview}
                                                            currentCurrencyData={currentCurrencyData} rowData={row}
                                                            sectionData={section} rowIndex={rowIndex}
                                                            rowDiscount={rowDiscount}
                                                            handleRowDiscount={handleRowDiscount}
                                                            updateRowDicount={updateRowDicount}
                                                            rowTax={rowTax}
                                                            handleRowTax={handleRowTax}
                                                            input_type={col?.input_type}
                                                            field_label={col?.extra_fields?.field_label}
                                                            isOverallTax={isOverallTax}
                                                            showFrom={showFrom}
                                                            jobSuggestionData={jobSuggestionData} />
                                                    </>
                                        }
                                    </td>
                                ))}
                                <td>
                                    <span style={{ color: "#dc3545" }} className="cursor-pointer" onClick={() => removeRow(rowIndex)}>
                                        <i className="fas fa-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button type='button' className="btn btn-primary mt-2" onClick={addRow}>
                Add Row
            </button>
        </div>
    );
};

export default DynamicTable;
